var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2955_3723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2955_3723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 24.0833C17.4014 24.0833 17.7378 23.9476 18.0094 23.676C18.2809 23.4045 18.4167 23.0681 18.4167 22.6667C18.4167 22.2653 18.2809 21.9288 18.0094 21.6573C17.7378 21.3858 17.4014 21.25 17 21.25C16.5986 21.25 16.2622 21.3858 15.9906 21.6573C15.7191 21.9288 15.5833 22.2653 15.5833 22.6667C15.5833 23.0681 15.7191 23.4045 15.9906 23.676C16.2622 23.9476 16.5986 24.0833 17 24.0833ZM17 18.4167C17.4014 18.4167 17.7378 18.2809 18.0094 18.0094C18.2809 17.7378 18.4167 17.4014 18.4167 17V11.3333C18.4167 10.9319 18.2809 10.5955 18.0094 10.324C17.7378 10.0524 17.4014 9.91667 17 9.91667C16.5986 9.91667 16.2622 10.0524 15.9906 10.324C15.7191 10.5955 15.5833 10.9319 15.5833 11.3333V17C15.5833 17.4014 15.7191 17.7378 15.9906 18.0094C16.2622 18.2809 16.5986 18.4167 17 18.4167ZM12.8562 29.75C12.4785 29.75 12.1184 29.6792 11.776 29.5375C11.4337 29.3958 11.1326 29.1951 10.8729 28.9354L5.06458 23.1271C4.80486 22.8674 4.60417 22.5663 4.4625 22.224C4.32083 21.8816 4.25 21.5215 4.25 21.1437V12.8562C4.25 12.4785 4.32083 12.1184 4.4625 11.776C4.60417 11.4337 4.80486 11.1326 5.06458 10.8729L10.8729 5.06458C11.1326 4.80486 11.4337 4.60417 11.776 4.4625C12.1184 4.32083 12.4785 4.25 12.8562 4.25H21.1437C21.5215 4.25 21.8816 4.32083 22.224 4.4625C22.5663 4.60417 22.8674 4.80486 23.1271 5.06458L28.9354 10.8729C29.1951 11.1326 29.3958 11.4337 29.5375 11.776C29.6792 12.1184 29.75 12.4785 29.75 12.8562V21.1437C29.75 21.5215 29.6792 21.8816 29.5375 22.224C29.3958 22.5663 29.1951 22.8674 28.9354 23.1271L23.1271 28.9354C22.8674 29.1951 22.5663 29.3958 22.224 29.5375C21.8816 29.6792 21.5215 29.75 21.1437 29.75H12.8562ZM12.8917 26.9167H21.1083L26.9167 21.1083V12.8917L21.1083 7.08333H12.8917L7.08333 12.8917V21.1083L12.8917 26.9167Z",
    fill: "#F04438"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.373c0466df0958b9ba112a0a2f8bc316.svg";
export { ForwardRef as ReactComponent };